<template>
  <div class="c-note">
    <p v-if="$slots.title" class="c-note__title">
      <Icon2 variant="attention" :size="14" />
      <slot name="title"></slot>
    </p>
    <div class="c-note__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';

export default {
  components: {
    Icon2
  }
};
</script>
